import { useState } from 'react';

import { ModuleItem } from '~components/generic/module/ModuleItem/ModuleItem';
import { ModuleSearch } from '~components/generic/module/ModuleSearch/ModuleSearch';
import { getAllowedModules, getEntityDefinition } from '~services/entity-definitions';

interface ModuleListProps {
  parentContext: string;
  index: number;
  type: string;
  onChooseItem: () => void;
}

export const ModulesList = ({ parentContext, index, type, onChooseItem }: ModuleListProps) => {
  const entityDef = getEntityDefinition(type);
  const options = entityDef.settings.modules.fields['relationships.field_modules.data'].options;
  const validEntities = getAllowedModules(options);
  const [searchInput, setSearchInput] = useState('');

  const filteredModules = validEntities.filter(module => {
    const moduleName = module.replace('paragraph--', '');
    return moduleName.toLowerCase().includes(searchInput.toLowerCase());
  });

  const onSearchInput = value => {
    setSearchInput(value);
  };

  return (
    <div className="module-list w-full">
      <ModuleSearch onSearchInput={onSearchInput} />
      <div className="row">
        {filteredModules.map((entityType, i) => {
          return (
            <div key={i} className="col-3">
              <ModuleItem
                onChooseItem={onChooseItem}
                index={index}
                parentContext={parentContext}
                entityType={entityType}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ModulesList;
